import { createFileRoute } from "@tanstack/react-router";
import { RoleLoginForm } from "@/components/auth/RoleLoginForm";

export const Route = createFileRoute("/login/provider")({
  component: () => <RoleLoginForm role="provider" />,
});
